// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-2fO5n";
export { _1 as "__esModule", _2 as "button" }
export default { "__esModule": _1, "button": _2 }
